import React from "react";
import PropTypes from "prop-types";

function View(props) {
  const {src, alt, title, className, onClick} = props;
  return (
    <div className={className} onClick={onClick}>
      {src ? <img src={src} alt={alt} title={title} /> : <span></span>}
    </div>
  );
}

View.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default View;
